// extracted by mini-css-extract-plugin
export default {"case":"CasePage_case__bNaBG"};